import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import './vehicleSeatingLayout.css';
import steering from "../../../assets/images/steering-wheel.png";
import chair from "../../../assets/images/armChair.png";
import selectedChair from "../../../assets/images/selectedArmChair.png";

const VehicleSeatingLayout = ({
  layoutData,
  orientation = 'up', // 'up' | 'down' | 'left' | 'right'
  mode = 'edit', // 'view' | 'edit'
  onSelectedSeat,
  initialSelectedSeats = [],
}) => {
  const [selectedSeats, setSelectedSeats] = useState(initialSelectedSeats);

  if (!layoutData || !Array.isArray(layoutData.layout)) {
    return <div>Loading layout...</div>;
  }

  const { layout } = layoutData;

  const handleSave = () => {
    if (typeof onSelectedSeat === 'function') {
      onSelectedSeat(selectedSeats);
    }
  };

  const handleSeatClick = (seatId) => {
    if (
      mode === 'view' ||
      seatId === '-' ||
      seatId === '0'
    ) {
      return;
    }
    setSelectedSeats((prevSelected) =>
      prevSelected.includes(seatId)
        ? prevSelected.filter((id) => id !== seatId)
        : [...prevSelected, seatId]
    );
  };

  return (
    <div className="seating-wrapper">
      <div className={`bus-container orientation-${orientation}`}>
        <div className="seat-grid">
          {layout.map((row, rowIndex) => (
            <div key={`row-${row.join('_')}`} className="seat-row">
              {row.map((seat, colIndex) => {
                // Aisle
                if (seat === '-') {
                  return (
                    <div
                      key={`empty-${rowIndex}-${colIndex}`}
                      className="seat aisle"
                    />
                  );
                }

                // Driver seat
                if (seat === '0') {
                  return (
                    <div
                      key={`driver-${rowIndex}-${colIndex}`}
                      className="driver-seat"
                      title="Driver Seat"
                    >
                      <img
                        src={steering}
                        alt="steering"
                        className="steering-img"
                      />
                    </div>
                  );
                }

                // Regular seat
                const isSelected = selectedSeats.includes(seat);
                return (
                  <button
                    key={`seat-${seat}-${rowIndex}-${colIndex}`}
                    type="button"
                    className={`seat-btn orientation-${orientation} ${isSelected ? 'selected' : ''} ${
                      mode === 'view' ? 'view-only' : ''
                    }`}
                    onClick={() => handleSeatClick(seat)}
                    disabled={mode === 'view'}
                    title={`Seat ${seat}`}
                  >
                    <img
                      src={isSelected ? selectedChair : chair}
                      alt={`Seat ${seat}`}
                      className="chair-img"
                    />
                    <span className="seat-number">{seat}</span>
                  </button>
                );
              })}
            </div>
          ))}
        </div>
      </div>
      {mode === 'edit' && (
        <div className="layout-actions mt-3">
          <Button
            onClick={handleSave}
            className="ms-2"
            bsPrefix="confirm-btn"
          >
            Save
          </Button>
        </div>
      )}
    </div>
  );
};

VehicleSeatingLayout.propTypes = {
  layoutData: PropTypes.shape({
    layout: PropTypes.array,
    name: PropTypes.string,
  }),
  orientation: PropTypes.string,
  mode: PropTypes.string,
  onSelectedSeat: PropTypes.func,
  initialSelectedSeats: PropTypes.array,
};

export default VehicleSeatingLayout;